<div class="video-player">
	<header class="video-player-header">
		<h2 class="video-player-title">{{ title || video.name }}</h2>
		<button
			type="button"
			class="video-player-close"
			(click)="close()"
			[attr.aria-label]="'NOTE_EDITOR__CLOSE' | transloco"
		>
			<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">close</span>
		</button>
	</header>

	<div class="video-player-body">
		<div *ngIf="video.providerSettings.type === 'Vimeo'" class="video-player-frame video-player-frame--vimeo">
			<iframe
				[src]="videoUrl"
				frameborder="0"
				allow="autoplay; fullscreen; picture-in-picture"
				allowfullscreen
			></iframe>
		</div>

		<div *ngIf="video.providerSettings.type === 'YouTube'" class="video-player-frame video-player-frame--youtube">
			<iframe
				[src]="videoUrl"
				frameborder="0"
				webkitallowfullscreen
				mozallowfullscreen
				allowfullscreen
			></iframe>
		</div>
	</div>
</div>
